import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client, useScopedMerchantClient } from "./scoped-merchant-client";

export const useCreatorFilters = () => {
  const scope = useScopedMerchantClient();

  return useQuery({
    queryKey: ["creator", scope.merchantId, scope.workspaceId, "filters"],
    queryFn: async () => {
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].creator.filters.$get({
            param: scope.param,
          })
        : await client.merchant[":merchantId"].creator.filters.$get({
            param: scope.param,
          });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: !!scope.merchantId,
    staleTime: 5 * 60 * 1000,
  });
};
